// const API_URL = 'http://localhost:5000/api';
const API_URL = 'https://cabanaapi.octaviantweaking.com/api';


/* ── Helper: make authenticated requests ── */
async function request(endpoint, options = {}) {
  const token = localStorage.getItem('token');

  // If we're sending FormData, the browser must set the multipart boundary.
  const isFormData = typeof FormData !== 'undefined' && options.body instanceof FormData;

  const headers = {
    ...(token && { Authorization: `Bearer ${token}` }),
    ...options.headers,
  };

  if (!isFormData) {
    headers['Content-Type'] = headers['Content-Type'] || 'application/json';
  }

  const config = {
    ...options,
    headers,
  };

  const response = await fetch(`${API_URL}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`, config);
  
  if (!response.ok) {
    let data;
    try {
      data = await response.json();
    } catch {
      data = {};
    }
    throw new Error(data.error || 'Something went wrong');
  }

  const data = await response.json();
  return data;
}

/* ── Auth API ── */
export const api = {
  // Register a new user
  register: (email, password, full_name, phone) =>
    request('/auth/register', {
      method: 'POST',
      body: JSON.stringify({ email, password, full_name, phone }),
    }),

  // Login
  login: (email, password) =>
    request('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    }),

  // Get current user profile
  getProfile: () => request('/auth/me'),

  // Update profile
  updateProfile: (updates) =>
    request('/auth/me', {
      method: 'PUT',
      body: JSON.stringify(updates),
    }),

  // Get all bookings (public — for calendar)
  getBookings: () => request('/bookings'),

  // Get my bookings (protected)
  getMyBookings: () => request('/bookings/mine'),

  // Get my booking stats & loyalty info (protected)
  getMyStats: () => request('/bookings/stats'),

  // Create a booking (protected)
  createBooking: (check_in, check_out, guests, notes) =>
    request('/bookings', {
      method: 'POST',
      body: JSON.stringify({ check_in, check_out, guests, notes }),
    }),

  // Cancel a booking (protected)
  cancelBooking: (id) =>
    request(`/bookings/${id}`, {
      method: 'DELETE',
    }),

  // ── Reviews ──

  // Get all reviews (public)
  getReviews: () => request('/reviews'),

  // Create a review (protected)
  createReview: (review) =>
    request('/reviews', {
      method: 'POST',
      body: JSON.stringify(review),
    }),

  // Update a review (protected)
  updateReview: (id, review) =>
    request(`/reviews/${id}`, {
      method: 'PUT',
      body: JSON.stringify(review),
    }),

  // Delete a review (protected)
  deleteReview: (id) =>
    request(`/reviews/${id}`, {
      method: 'DELETE',
    }),

  // Toggle helpful vote (protected)
  toggleHelpful: (id) =>
    request(`/reviews/${id}/helpful`, {
      method: 'POST',
    }),

  // Get my helpful votes (protected)
  getMyVotes: () => request('/reviews/my-votes'),

  // ── Memories ──
  listMemories: () => request('/memories'),

  uploadMemories: (photos, caption = '') => {
    const fd = new FormData();
    const arr = Array.isArray(photos) ? photos : [photos];
    arr.slice(0, 10).forEach((p) => fd.append('photos', p));
    fd.append('caption', caption);

    // Convenience: include user name if we have it (server treats as optional)
    try {
      const raw = localStorage.getItem('user');
      if (raw) {
        const u = JSON.parse(raw);
        if (u?.full_name) fd.append('user_name', u.full_name);
      }
    } catch {
      // ignore
    }

    return request('/memories', {
      method: 'POST',
      body: fd,
    });
  },
};
